// import hsFetch from 'hellospa/hs-fetch';

const TOURS_KEY = 'tours';

export type TourShape = {
  completed: boolean,
};

export type TourDataShape = {
  [tour: string]: TourShape,
};

/**
 * Sets the tour data in local storage.
 */
export const setTourData = (tours: TourDataShape) => {
  window.localStorage.setItem(TOURS_KEY, JSON.stringify(tours));
};

/**
 * Gets the tour data from local storage. If no such data
 * exists, an empty array is returned.
 */
export const getTourData = () => {
  const toursJson = window.localStorage.getItem(TOURS_KEY);
  let tours: TourDataShape = {};

  if (toursJson) {
    try {
      tours = JSON.parse(toursJson);
    } catch (err) {
      // Ignore; JSON is malformed. Ignore existing data
      // and start from scratch.
      setTourData({});
    }
  }

  return tours;
};

/**
 * Merges existing tour data with new tour data.
 */
export const mergeTourData = (newTourData: TourDataShape) => {
  setTourData({
    ...getTourData(),
    ...newTourData,
  });
};

/*
 * These functions are hellosign-web's API to HelloFax. Please keep
 * implementation details about building the requests here. For example, don't
 * pass in a `body` or `url`, pass the object you're working with and have this function
 * construct the body and url. You don't need the CSRF token, it's handled by hsFetch with the
 * X-CSRF-Token header.
 *
 *
 */

export const completeTour = async (tour: string) => {

  // Using local storage for now. Remove when DEV-14121 is
  // implemented.
  mergeTourData({
    [tour]: {
      completed: true,
    },
  });

  return {
    success: true,
  };

  // TODO: https://hellosign.atlassian.net/browse/DEV-14121
  // const url = 'TODO';
  // const request = await hsFetch(url, {
  //   // hsFetch will provide the CSRF token automatically in the header
  //   //
  //   // headers: { 'X-CSRF-Token': ... }
  //   method: 'POST',
  //   body: JSON.stringify({
  //     tour,
  //   }),
  //   // hsFetch also assumes we're always fetching JSON, but you can override it
  //   // if necessary.
  //   //
  //   // headers: { Accept: 'application/json' }
  // });

  // const data = await request.json();

  // /**
  //  * request.json() returns an any, so it shouldn't just be returned directly.
  //  * Explicitly building the object also documents the API and assists
  //  * TypeScript in inferring the type.
  //  *
  //  * This is also a good place to convert between naming conventions:
  //  * tourId: data.tour_id,
  //  */
  // return {
  //   success: Boolean(data.success),
  // };
};

export const isTourActive = (tour: string) => {
  const tours = getTourData();

  if (tour in tours) {
    if (tours[tour].completed) {
      return false;
    }
  }

  return true;
};
